angular.module("leanlaw").directive("llInvoiceReviewFilter", ["billingFilterService", function (billingFilterService) {
  return {
    restrict: "EA",
    template: require("./views/filter.html"),
    controller: ["$scope", function ($scope) {
      $scope.state = billingFilterService.state;
    }]
  };
}]);